import { createAction, props } from '@ngrx/store';

export const setPermissions = createAction('[Permission] Set Permissions', props<{ permissions: string[] }>());
export const clearPermissions = createAction('[Permission] Clear Permissions');
